const PRETTY_INDENT = 2;

export const toJsonEditorValue = (raw: unknown): string => {
  if (raw === null || raw === undefined) {
    return '';
  }
  if (typeof raw === 'string') {
    return raw;
  }
  try {
    return JSON.stringify(raw, null, PRETTY_INDENT);
  } catch {
    return String(raw);
  }
};
